import ProductsLayout from './ProductsLayout';
import MaterialsPage from '../pages/MaterialsPage';

/**
 * 生成スタジオ用レイアウト
 * MaterialsPageをラップし、ルーティングで使用
 */
export default function StudioLayout() {
  return (
    <ProductsLayout>
      <MaterialsPage />
    </ProductsLayout>
  );
}
